import { useState,useEffect} from 'react';
import { Helmet } from 'react-helmet-async';
import Sidebar from './sidebar';
import api from '../api';
import "react-phone-input-2/lib/bootstrap.css";
import { Copy, ExternalLink, Eye, EyeOff, Key, Lock } from 'react-feather';
import useStoreSetupCheck from './useStoreSetupCheck';
import wlogo from "../../feature/wlogo.jpg";

function SellerProfileApiKey(){
    useStoreSetupCheck();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [ProfileData,setProfileData]=useState({  
         "api_key": "",
    });

    const [showKey, setShowKey] = useState(false);

    const maskedKey = ProfileData.api_key
    ? "•".repeat(24) + ProfileData.api_key.slice(-6)
    : "";

    const token = localStorage.getItem("access_token");
    
    useEffect(()=>{
        fetchData();
    },[]);


    const clean = (v) =>
        v === null || v === undefined || v === "null" ? "" : v;

    const fetchData = async () => {
        try {
            const response = await api.get(baseUrl+'/vendor/', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = response.data;

            setProfileData({
                api_key: clean(data.api_key),
            });

        } catch (error) {
            //setError('Failed to fetch customer data. Please try again later.');
        } finally {
            //setLoading(false);
        }
    };


    const [copied, setCopied] = useState(false);

    const handleCopyApiKey = () => {
        if (!ProfileData.api_key) return;

        navigator.clipboard.writeText(ProfileData.api_key);
        setCopied(true);

        setTimeout(() => setCopied(false), 2000);
    };


    return (
        <>                            
            <Helmet>
                <title>API Key</title>
                <meta name="description" content={`Profile`} />
            </Helmet>
            <section className="container mtopcon dashb">
                <div className="row">
                    <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max">
                            
                            <div className="row mb-3 ph-header-con">
                                <div className="col-12 pt-2"><h6 className="pageheader-title mb-3">Kadhr WooCommerce API Key </h6></div>
                            </div>
                            <div className="row d-flex justify-content-center">
                                <div className="col-12 col-lg-4">                                    
                                    <div className="card shadow-sm border border-secondary border-opacity-10 mb-4">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                <div>
                                                    <h6
                                                        className="mb-1 fw-bold"
                                                        style={{
                                                            fontSize: "1rem",
                                                        }}
                                                    >
                                                        API Access
                                                    </h6>

                                                    <div
                                                        style={{
                                                            fontSize: "0.8em",
                                                            color: "#6b7280",
                                                            lineHeight: "1.6",
                                                        }}
                                                    >
                                                        Connect your store, website, ERP, POS, mobile app, or custom
                                                        integrations to Kadhr using your private API key.
                                                    </div>
                                                </div>

                                                <span
                                                    style={{
                                                        background: "#eef6ff",
                                                        color: "#2563eb",
                                                        padding: "0.25rem 0.65rem",
                                                        borderRadius: "999px",
                                                        fontWeight: 600,
                                                        marginTop:"-0.4em",
                                                    }}
                                                >
                                                    <Key  width={'1em'}/>
                                                </span>
                                            </div>

                                            {/* Security Note */}
                                            <div
                                                className="mb-3 p-2"
                                                style={{
                                                    background: "#f8fafc",
                                                    border: "1px solid #e5e7eb",
                                                    borderRadius: "10px",
                                                    fontSize: "0.75em",
                                                    color: "#6b7280",
                                                    lineHeight: "1.5",
                                                }}
                                            >
                                                <Lock width={'1em'}/> Keep this key secure. Anyone with access to it can connect to your
                                                Kadhr account and interact with your data.
                                            </div>

                                            {/* Key Input */}
                                            <div className="input-group">

                                                <input
                                                    type="text"
                                                    className="form-control border border-secondary"
                                                    style={{
                                                        fontSize: "0.85em",
                                                    }}
                                                    value={showKey ? ProfileData.api_key : maskedKey}
                                                    readOnly
                                                />

                                                {/* Show / Hide */}
                                                <button
                                                    className="btn btn-outline-secondary"
                                                    onClick={() => setShowKey(!showKey)}
                                                    title={showKey ? "Hide API Key" : "Show API Key"}
                                                >
                                                    {showKey ? (
                                                        <Eye className="text-dark" width={'1em'} />
                                                    ) : (
                                                        <EyeOff className="text-dark" width={'1em'} />
                                                    )}
                                                </button>

                                                {/* Copy */}
                                                <button
                                                    className="btn btn-dark"
                                                    onClick={handleCopyApiKey}
                                                    title="Copy API Key"
                                                >
                                                    <Copy  width={'1em'}/>
                                                </button>

                                            </div>

                                            {/* Success Message */}
                                            {copied && (
                                                <div
                                                    className="mt-2"
                                                    style={{
                                                        fontSize: "0.75em",
                                                        color: "#16a34a",
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    ✓ API key copied to clipboard
                                                </div>
                                            )}

                                            {/* Footer */}
                                            <div
                                                className="mt-4 pt-3"
                                                style={{
                                                    borderTop: "1px solid #f1f5f9",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "0.72em",
                                                        color: "#6b7280",
                                                        lineHeight: "1.6",
                                                    }}
                                                >
                                                    Use this key to authenticate API requests and connect external
                                                    platforms such as WooCommerce, custom websites, mobile apps,
                                                    automation tools, and internal business systems.
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    {/* Integrations */}
                                    <div
                                        className="mt-4 pt-4"
                                        style={{
                                            borderTop: "1px solid #f1f5f9",
                                        }}
                                    >

                                        <div className="mb-3">
                                            <div
                                                style={{
                                                    fontSize: "0.95em",
                                                    fontWeight: 600,
                                                    color: "#111827",
                                                }}
                                            >
                                                Integrations
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "0.78em",
                                                    color: "#6b7280",
                                                    marginTop: "2px",
                                                }}
                                            >
                                                Connect your existing tools and automatically sync data with Kadhr.
                                            </div>
                                        </div>

                                        <div className="accordion" id="integrationAccordion">

                                            {/* WooCommerce */}
                                            <div
                                                className="accordion-item mb-6"
                                                style={{
                                                    border: "1px solid #e5e7eb",
                                                    borderRadius: "14px",
                                                    overflow: "hidden",
                                                    background: "#fff",
                                                }}
                                            >

                                                <h2 className="accordion-header">

                                                    <button
                                                        className="accordion-button collapsed shadow-none"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#woocommerceIntegration"
                                                        style={{
                                                            background: "#fff",
                                                            padding: "1rem",
                                                        }}
                                                    >

                                                        <div className="d-flex align-items-center w-100">

                                                            {/* Logo */}
                                                            <div
                                                                className="me-3"
                                                                style={{
                                                                    width: "48px",
                                                                    height: "48px",
                                                                    borderRadius: "12px",
                                                                    background: "#f8fafc",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    flexShrink: 0,
                                                                }}
                                                            >
                                                                <img
                                                                    src={wlogo}
                                                                    alt="WooCommerce"
                                                                    style={{
                                                                        width: "100%",
                                                                        objectFit: "contain",
                                                                    }}
                                                                />
                                                            </div>

                                                            {/* Content */}
                                                            <div className="flex-grow-1">

                                                                <div
                                                                    style={{
                                                                        fontSize: "0.9em",
                                                                        fontWeight: 600,
                                                                        color: "#111827",
                                                                    }}
                                                                >
                                                                    WooCommerce 
                                                                    <span
                                                                        className="ms-2 bg-success-subtle text-success font7"
                                                                        style={{
                                                                            padding: "0.12rem 0.2rem",
                                                                            borderRadius: "0.375rem",
                                                                            fontWeight: 600,
                                                                            position:"absolute",
                                                                        }}
                                                                    >
                                                                        Active
                                                                    </span>
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        fontSize: "0.75em",
                                                                        color: "#6b7280",
                                                                        marginTop: "2px",
                                                                    }}
                                                                >
                                                                    Automatically sync products, customers and orders.
                                                                </div>

                                                            </div>

                                                            

                                                        </div>

                                                    </button>

                                                </h2>

                                                <div
                                                    id="woocommerceIntegration"
                                                    className="accordion-collapse collapse"
                                                    data-bs-parent="#integrationAccordion"
                                                >

                                                    <div
                                                        className="accordion-body"
                                                        style={{
                                                            borderTop: "1px solid #f1f5f9",
                                                        }}
                                                    >

                                                        {/* Intro */}
                                                        <div
                                                            className="mb-4 p-3"
                                                            style={{
                                                                background: "#f8fafc",
                                                                borderRadius: "12px",
                                                                border: "1px solid #e5e7eb",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    fontSize: "0.85em",
                                                                    fontWeight: 600,
                                                                    color: "#111827",
                                                                    marginBottom: "6px",
                                                                }}
                                                            >
                                                                Connect WooCommerce in under 2 minutes
                                                            </div>

                                                            <div
                                                                style={{
                                                                    fontSize: "0.75em",
                                                                    color: "#6b7280",
                                                                    lineHeight: "1.6",
                                                                }}
                                                            >
                                                                Once connected, Kadhr will automatically import
                                                                customers, orders and products from your
                                                                WooCommerce store.
                                                            </div>
                                                        </div>

                                                        {/* Steps */}
                                                        <div className="mb-4">

                                                            {[
                                                                "Install the Kadhr WooCommerce Plugin.",
                                                                "Open WooCommerce → Kadhr Integration.",
                                                                "Copy your Kadhr API Key above.",
                                                                "Paste the key into the plugin settings.",
                                                                "Click Connect Store.",
                                                                "Run your first sync."
                                                            ].map((step, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="d-flex mb-3"
                                                                >

                                                                    <div
                                                                        style={{
                                                                            width: "24px",
                                                                            height: "24px",
                                                                            borderRadius: "50%",
                                                                            background: "#eef6ff",
                                                                            color: "#2563eb",
                                                                            fontSize: "0.75em",
                                                                            fontWeight: 600,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            marginRight: "12px",
                                                                            flexShrink: 0,
                                                                        }}
                                                                    >
                                                                        {index + 1}
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                            fontSize: "0.8em",
                                                                            color: "#374151",
                                                                            lineHeight: "1.5",
                                                                        }}
                                                                    >
                                                                        {step}
                                                                    </div>

                                                                </div>
                                                            ))}

                                                        </div>

                                                        {/* CTA */}
                                                        <div
                                                            className="p-3"
                                                            style={{
                                                                background: "#fefaf5",
                                                                border: "1px solid #f6d7b8",
                                                                borderRadius: "12px",
                                                            }}
                                                        >

                                                            <div
                                                                style={{
                                                                    fontSize: "0.85em",
                                                                    fontWeight: 600,
                                                                    color: "#111827",
                                                                }}
                                                            >
                                                                Need detailed setup instructions?
                                                            </div>

                                                            <div
                                                                style={{
                                                                    fontSize: "0.75em",
                                                                    color: "#6b7280",
                                                                    marginTop: "4px",
                                                                    lineHeight: "1.5",
                                                                }}
                                                            >
                                                                Follow our complete installation guide with
                                                                screenshots, troubleshooting tips and plugin
                                                                updates.
                                                            </div>

                                                            <button
                                                                className="btn btn-dark btn-sm mt-3 d-inline-flex align-items-center gap-2"
                                                                onClick={() =>
                                                                    window.open("/woocommerce-plugin", "_blank", "noopener,noreferrer")
                                                                }
                                                            >
                                                                Installation Guide
                                                                <ExternalLink width="1em" />
                                                            </button>
                                                            

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SellerProfileApiKey;